import { useQuery } from '@tanstack/react-query';
import { fetchActivityList } from '../api/activityApi';
import type { ActivityFilters } from '../types';

export const ACTIVITY_PAGE_SIZE = 25;

export type { ActivityFilters } from '../types';

export function useActivityList(
  filters: ActivityFilters,
  page: number,
  take = ACTIVITY_PAGE_SIZE,
  enabled = true
) {
  return useQuery({
    queryKey: ['activity', filters, page, take],
    queryFn: ({ signal }) =>
      fetchActivityList(filters, page * take, take, signal),
    enabled,
    staleTime: 30000,
  });
}
